interface Props {
  episode: number;
  series: string;
}

export default function EpisodeMeta({ episode, series }: Props) {
  return (
    <div className="episode-meta">
      <span className="ep-number">Episode {String(episode).padStart(2, "0")}</span>
      <div className="ep-divider" />
      <span className="ep-series">{series}</span>
    </div>
  );
}
